import React from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import { optionLineEchart } from "../../Data/Charts";

class StackedAreaChart extends React.Component {
  componentDidMount() {
    this.chartPlace();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profits !== this.props.profits) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { profitData } = this.props;
    const allMonths = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
    const profitDataMap = {};

    allMonths.forEach((month) => {
      profitDataMap[month] = 0;
    });

    if (profitData) {
      Object.keys(profitData).forEach((category) => {
        const categoryData = profitData[category];
        Object.keys(categoryData).forEach((month) => {
          profitDataMap[month] = categoryData[month].total_profit;
        });
      });
    }

    const months = Object.keys(profitDataMap);
    const profitDatas = Object.values(profitDataMap);

    const chartDom = document.getElementById("StackedAreaChart");
    const myChart = echarts.init(chartDom);
    const option = {
      ...optionLineEchart,
      xAxis: [
        {
          ...optionLineEchart.xAxis[0],
          data: months,
        },
      ],
      series: [
        {
          name: "Aylık Kâr",
          type: "line",
          stack: "Toplam",
          areaStyle: {},
          data: profitDatas,
        },
      ],
    };
    myChart.setOption(option);
  };


  render() {
    return (
        <div id="StackedAreaChart" style={{height: 390}}></div>
    );
  }
}

const mapStateToProps = (state) => ({
  profitData: state.analyticalReducer.profitData,
});

export default connect(mapStateToProps, {})(StackedAreaChart);
